import { defineComponent as I, computed as r, createElementBlock as y, openBlock as a, normalizeClass as i, createVNode as c, createBlock as n, createCommentVNode as m, unref as t, withCtx as b, resolveDynamicComponent as g } from "vue";
import { RevButtonBase as x } from "@ds/components/ButtonBase";
import { RevButtonIcon as h } from "@ds/components/ButtonIcon";
import { RevIllustration as C } from "@ds/components/Illustration";
import D from "../../../icons/generated/IconCross.vue2.js";
import A from "../../../icons/generated/IconDownload.vue2.js";
import { tw as u } from "../../../utils/tailwind.js";
import { isImage as k, isArchive as L, isTextDocument as $, isSpreadsheet as N, isPresentation as P } from "../Document.helpers.js";
import R from "../assets/IconArchive.vue.js";
import T from "../assets/IconDoc.vue.js";
import j from "../assets/IconImage.vue.js";
import S from "../assets/IconPDF.vue.js";
import V from "../assets/IconPresentation.vue.js";
import z from "../assets/IconSpreadsheet.vue.js";
import E from "./DocumentLabelWrapper.vue2.js";
import F from "./DocumentName.vue2.js";
const ae = /* @__PURE__ */ I({
  name: "DocumentDefault",
  __name: "DocumentDefault",
  props: {
    name: {},
    url: {},
    deletable: { type: Boolean },
    thumbnail: { type: Boolean },
    downloadButtonAriaLabel: {},
    deleteButtonAriaLabel: {}
  },
  emits: ["delete"],
  setup(e, { emit: v }) {
    const l = e, w = v, p = r(() => {
      const d = [
        { check: k, icon: j },
        { check: L, icon: R },
        { check: $, icon: T },
        { check: N, icon: z },
        { check: P, icon: V }
      ];
      for (const o of d)
        if (o.check(l.name)) return o.icon;
      return S;
    }), s = r(
      () => l.url && l.thumbnail && k(l.name)
    ), B = r(() => [
      u`border-static-default-mid group relative w-full border`,
      s.value && u`flex-col`
    ]), f = u`absolute bottom-12 right-12`;
    return (d, o) => (a(), y("article", {
      class: i(B.value)
    }, [
      c(t(x), {
        class: "focus-visible-outline-default-hi block max-w-full rounded-[5px]",
        target: "_blank",
        to: e.url
      }, {
        default: b(() => [
          s.value ? (a(), n(t(C), {
            key: 0,
            alt: "",
            height: 140,
            "image-class-names": "rounded-t-sm h-[8.75rem] w-full object-cover object-center",
            src: e.url,
            title: e.name,
            width: 448
          }, null, 8, ["src", "title"])) : m("", !0),
          c(E, { class: "w-full max-w-full overflow-hidden py-20 pr-48" }, {
            default: b(() => [
              (a(), n(g(p.value), {
                class: "shrink-0",
                height: "20",
                width: "20"
              })),
              c(F, { name: e.name }, null, 8, ["name"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"]),
      e.url && !e.deletable ? (a(), n(t(h), {
        key: 0,
        "aria-label": e.downloadButtonAriaLabel,
        class: i(f),
        download: e.name,
        icon: t(A),
        target: "_blank",
        to: e.url,
        variant: "secondary"
      }, null, 8, ["aria-label", "download", "icon", "to"])) : m("", !0),
      e.deletable ? (a(), n(t(h), {
        key: 1,
        "aria-label": e.deleteButtonAriaLabel,
        class: i(f),
        icon: t(D),
        variant: "secondary",
        onClick: o[0] || (o[0] = (q) => w("delete"))
      }, null, 8, ["aria-label", "icon"])) : m("", !0)
    ], 2));
  }
});
export {
  ae as default
};
